import React from "react";
import "../../../../style/alerts.scss";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@material-ui/core";

interface IProps {
  assigned: boolean;
  startTime: number;
  saleFrom: number;
  status: string;
  waitList: boolean;
  waitListPosition: number;
  deputyName?: string;
}

const SingleAlertsExercise: React.FC<IProps> = ({
  assigned,
  startTime,
  saleFrom,
  status,
  waitList,
  waitListPosition,
  deputyName,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="alert-line-exercise">
        {deputyName && (
          <Tooltip title={t("zastepstwo")}>
            <div className="zastepstwo">!</div>
          </Tooltip>
        )}

        {assigned && waitList === false && <div className="zapisany">Jesteś zapisany</div>}

        {waitList === true && (
          <div className="lista">
            {t("lista_rezerwowa")} ({waitListPosition})
          </div>
        )}
      </div>

      {/* 
      {assigned && waitList === false && (
        <b className="alert-center alert alert-green alert-small ">{t("jestes_zapisany")}</b>
     
      <HtmlTooltip
        placement="bottom-start"
        title={
          <>
            <article
              className="tooltip-description"
              dangerouslySetInnerHTML={{
                __html:
                  "Zapisanie się na listę rezerwową spowoduje, że zapiszemy Cie do kolejki osób oczekujących na rezerwacje. Jeśli ktoś zrezygnuje, to zapiszemy Ciebie.",
              }}
            ></article>
          </>
        }
      >
        <div>
          {waitList === true && <b className="alert-center alert alert-yellow alert-small ">{t("lista_rezerwowa")} ({waitListPosition})</b>}
        </div>
      </HtmlTooltip>
      {!future && status === "G" && (
        <b className="alert alert-yellow alert-small alert-center">{t("sprzedaz_nieaktywna")}</b>
      )} */}
    </>
  );
};

export default SingleAlertsExercise;
